const urlLinks = [
  "urllink",
  "placemenulink",
  "placelink",
  "placemoreinfolink",
  "placeslink",
  "maplink",
  "streetviewlink",
  "sectionlink",
  "imagelink",
  "guidelink",
  "schedulelink",
  "itinerarylink",
  "videolink",
  "audiolink",
  "pdflink",
  //"https",
  "Https",
  "directionslink",
  "weatherlink",
  "climatelink",
  "editcoverlink",
];

//href="schedulelink:One%20Day%20Tour"
//href="javascript:customLink('schedulelink:One%20Day%20Tour');"

export function urlSchemeToFunctions(html) {
  //html = htmlScaleAdjust(html);

  let more = true;
  let max = 0;
  while (more === true && max < 1000) {
    max++;
    more = false;
    for (let i = 0; i < urlLinks.length; i++) {
      if (urlLinks[i] === "") continue;
      let index1 = html.indexOf(`"${urlLinks[i]}:`);
      if (index1 !== -1) {
        //console.log("found:", `"${urlLinks[i]}:`);
        if (urlLinks[i] === "Https") {
          //console.log("substring", html.substring(index1 - 5, index1 - 1));
          if (html.substring(index1 - 5, index1 - 1) === "src") continue;
        }
        let index2 = html.indexOf('"', index1 + 1);
        //console.log(`index1=${index1}:index2=${index2}`);
        if (index2 > index1) {
          more = true;
          let link = html.substring(index1 + 1, index2);
          //console.log(`link:${link}:`);
          let link2 = link.replace(/:/, ";");

          html = html.replace(link, `javascript:void(0)" onclick="customLink('${link2}');`);
          // html = html.replace(`href="remove_this" `, "");
        }
      }
    }
  }
  //console.log("urlSchemeToFunctions, exit", html);
  return html;
}

export const getCSS = (html) => {
  let index1 = html.indexOf("<style>", 0);
  let index2 = html.indexOf("</style>", index1 + 1);
  let inline_style = "";
  let _html = html;
  if (index1 !== -1 && index2 !== -1) {
    inline_style = html.substring(index1 + 7, index2);
    _html = html.substring(index2 + 8);
  }
  const scale = htmlScaleFactor();
  let content_style = `a {color: #1913AB; text-decoration: none !important;} 
  a:visited {color: #661099;} a:active {color: red;}
  a:hover {color: purple; background: #AFB; } 
  .redtext {color: red;}`;
  //.home-resize-panel {transform-origin: top left; transform: scale(${scale.div}); font-size: ${scale.font};}
  content_style = content_style + inline_style;
  return { css: content_style, html: _html };
};

export function htmlScaleAdjust(html) {
  //if (html.includes("a {color: #1913AB; text-decoration: none !important;} ")) return html;
  let css_html = getCSS(html);
  // return "<style>" + css_html.css + "</style>" + css_html.html;

  console.log("window.innerWidth", window.innerWidth);
  let scale = "140%";
  if (window.innerWidth <= 280) scale = "240%";
  else if (window.innerWidth <= 320) scale = "208%";
  else if (window.innerWidth <= 375) scale = "190%";
  else if (window.innerWidth <= 414) scale = "160%";
  else if (window.innerWidth <= 540) scale = "140%";
  else if (window.innerWidth === 640) scale = "240%";
  else if (window.innerWidth <= 768) scale = "160%";
  else if (window.innerWidth <= 981) scale = "200%";
  else if (window.innerWidth <= 1024) scale = "180%";

  //console.log("urlSchemeToFunctions, enter", html);
  //if (html.includes("<html>")) html = html.replace("<html>", "<html font-size: 200%>");

  //if (!html.includes("<style>body {font-size: ")) {
  //html = `<style>body {font-size: ${scale}}</>` + html;

  //html = `<div class="usercontent"><style>body {font-size: ${scale};} .usercontent :not(img) {width: ${scale};}</style><br>${html}</div>`;

  //html = `<style>body {font-size: ${scale}; } .scalefix {width: ${scale};} ${css_html}</style>${html}`;

  // html = html.replace(/<p>/g, `<p class="scalefix">`);
  // html = html.replace(/<ul>/g, `<ul class="scalefix">`);
  // html = html.replace(/<div>/g, `<div class="scalefix">`);

  //html = html.replace(/<p style="text-align:center;">/g, `<p style="text-align:center;" class="scalefix">`);
  //html = html.replace(/<div><p/g, `<div class="scalefix">`);

  //html = html.replace(/<div>/g, `<p>`);

  //html = html.replace(/<\/div>/g, `</p>`);

  // html = html.replaceAll("<div></div>", "");
  // html = html.replaceAll("<div>", "");
  // html = html.replaceAll("</div>", "");
  //}
  return html;
}

export function htmlScaleFactor() {
  // return { font: "100%", div: 1.0 };
  console.log("window.innerWidth", window.innerWidth);
  let scale = "140%";
  if (window.innerWidth <= 280) scale = "240%";
  else if (window.innerWidth <= 320) scale = "208%";
  else if (window.innerWidth <= 375) scale = "190%";
  else if (window.innerWidth <= 414) scale = "160%";
  else if (window.innerWidth <= 540) scale = "140%";
  else if (window.innerWidth === 640) scale = "240%";
  else if (window.innerWidth <= 768) scale = "160%";
  else if (window.innerWidth <= 981) scale = "200%";
  else if (window.innerWidth <= 1024) scale = "180%";
  let div_scale = "0.714";
  if (window.innerWidth <= 280) div_scale = "0.417";
  else if (window.innerWidth <= 320) div_scale = "0.48";
  else if (window.innerWidth <= 375) div_scale = "0.52";
  else if (window.innerWidth <= 414) div_scale = "0.625";
  else if (window.innerWidth <= 540) div_scale = "0.714";
  else if (window.innerWidth === 640) div_scale = "0.417";
  else if (window.innerWidth <= 768) div_scale = "0.625";
  else if (window.innerWidth <= 981) div_scale = "0.5";
  else if (window.innerWidth <= 1024) div_scale = "0.714";

  return { font: scale, div: div_scale };
}
//<a href="#!" onClick={clickAction}>Link</a>
//<a href="#foo" onclick="customLink('sectionlink;769773062');"></a>

export function getHTMLContentCSS(fontZoom) {
  return `
    :root {
      --bg: #FAFAFA;
      --surface: #FFFFFF;
      --surface-sunken: #F4F4F5;
      --on-bg: #18181B;
      --on-surface: #18181B;
      --on-surface-muted: #71717A;
      --on-surface-faint: #A1A1AA;
      --border: #E4E4E7;
      --accent: #2F6FE5;
      --accent-subtle: #E6EEFB;
      --radius-lg: 20px;
      --radius-md: 10px;
    }
    * { box-sizing: border-box; }
    html { -webkit-text-size-adjust: 100%; }
    @keyframes _fadeIn { from { opacity: 0; } to { opacity: 1; } }
    body {
      margin: 0;
      padding: 24px 20px 64px;
      background: var(--bg);
      color: var(--on-bg);
      font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif;
      font-size: ${fontZoom ? fontZoom + "%" : "100%"};
      line-height: 1.55;
      -webkit-font-smoothing: antialiased;
      animation: _fadeIn 0.18s ease;
    }
    h1, h2, h3, h4, h5 {
      color: var(--on-bg);
      letter-spacing: -0.3px;
      line-height: 1.15;
      margin: 32px 0 14px 0;
      font-weight: 700;
    }
    h1 { font-size: 34px; letter-spacing: -0.8px; margin-top: 0; }
    h2 { font-size: 24px; }
    h3 { font-size: 12px; font-weight: 600; color: var(--on-surface-muted); text-transform: uppercase; letter-spacing: 0.8px; margin-top: 28px; margin-bottom: 10px; }
    h4 { font-size: 16px; font-weight: 600; }
    p {
      color: var(--on-surface);
      margin: 0 0 14px 0;
      line-height: 1.65;
    }
    a {
      color: var(--accent);
      text-decoration: none;
      font-weight: 600;
    }
    a:visited { color: var(--accent); }
    a:active { opacity: 0.7; }
    img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 16px auto;
      border-radius: var(--radius-lg);
      object-fit: cover;
      background: #E8E8E8;
    }
    p img { margin: 8px 0; }
    hr {
      border: 0;
      border-top: 1px solid var(--border);
      margin: 28px 0;
    }
    table {
      width: 100% !important;
      max-width: 100% !important;
      border-collapse: separate;
      border-spacing: 10px;
      margin: 16px 0;
    }
    table td { vertical-align: top; padding: 0; }
    table img { border-radius: var(--radius-lg); margin: 0; }
    blockquote {
      margin: 20px 0;
      padding: 16px 20px;
      background: var(--accent-subtle);
      border-radius: var(--radius-md);
      color: var(--on-surface);
    }
    iframe, embed, object {
      max-width: 100%;
      border-radius: var(--radius-md);
      border: 1px solid var(--border);
      margin: 16px 0;
    }
    .redtext { color: #DC2626; }
    ::selection { background: var(--accent-subtle); color: var(--on-bg); }
    a[style*="background"] {
      display: inline-flex !important;
      align-items: center !important;
      padding: 8px 16px !important;
      margin: 6px 6px 6px 0 !important;
      border-radius: 999px !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      letter-spacing: 0.1px !important;
      text-decoration: none !important;
      line-height: 1.2 !important;
      min-height: 32px !important;
      box-shadow: 0 1px 2px rgba(24, 24, 27, 0.06) !important;
    }
    p a[style*="background"], div a[style*="background"] {
      margin: 4px 6px 4px 0 !important;
    }
    ul {
      list-style: none !important;
      padding: 0 !important;
      margin: 8px 0 20px 0 !important;
    }
    ul li {
      padding: 0 !important;
      margin: 0 !important;
      border-bottom: 1px solid var(--border);
    }
    ul li:last-child { border-bottom: 0; }
    ul li a {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      padding: 14px 4px !important;
      color: var(--on-surface) !important;
      font-weight: 500 !important;
      text-decoration: none !important;
      font-size: 15px !important;
    }
    ul li a::after {
      content: "›";
      color: var(--on-surface-faint);
      font-size: 20px;
      font-weight: 400;
      margin-left: 12px;
      line-height: 1;
    }
    h4, b, strong {
      display: block;
      font-size: 12px !important;
      font-weight: 600 !important;
      letter-spacing: 0.8px !important;
      text-transform: uppercase !important;
      color: var(--on-surface-muted) !important;
      margin: 28px 0 10px 0 !important;
    }
    p b, p strong, li b, li strong, a b, a strong {
      display: inline !important;
      font-size: inherit !important;
      letter-spacing: normal !important;
      text-transform: none !important;
      color: inherit !important;
      margin: 0 !important;
      font-weight: 700 !important;
    }
  `;
}

export function buildDocument(body, fontZoom) {
  const css = getHTMLContentCSS(fontZoom);
  const PLACEHOLDER = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
  const script = `
    window.customLink = function(url) { if (window.parent && window.parent.customLink) window.parent.customLink(url); };
    window.coverImageFailed = function(img) { try { window.parent.coverImageFailed(img); } catch (e) {} };
    window.imgFallback = function(img) {
      var photo = img.getAttribute('data-photo');
      if (photo && img.src !== photo) {
        img.removeAttribute('data-photo');
        img.src = photo;
      } else {
        img.onerror = null;
        img.src = '${PLACEHOLDER}';
      }
    };
    function reportHeight() {
      var h = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (h > 0) window.parent.postMessage({ type: 'mosaicHeight', height: h }, '*');
    }
    window.addEventListener('load', reportHeight);
    document.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) img.addEventListener('load', reportHeight);
    });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(reportHeight).observe(document.body);
    }
  `.trim();
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>${css}</style></head><body>${body}<script>${script}</script></body></html>`;
}
